/* eslint-disable no-nested-ternary */

import Button from '@mui/material/Button';
import ButtonGroup, { ButtonGroupProps } from '@mui/material/ButtonGroup';
import { styled as styledMUI } from '@mui/material/styles';
import { StyledButtonProps } from './index.interfaces';

export const StyledButton = styledMUI(Button)<StyledButtonProps>(
  ({ selected, disabled }) => `
    border: 1px solid ${selected ? '#E30311' : '#B6BBB9'};
    border-radius: 16px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: ${selected ? 'white' : '#132C1D'};
    background-color: ${
      disabled
        ? selected
          ? '#aaaaaa80'
          : '#ffffff'
        : selected
          ? '#E30311'
          : '#ffffff'
    };
    text-transform: none;
    padding: 18px 0;
    `
);

export const StyledButtonGroup = styledMUI(ButtonGroup)<ButtonGroupProps>`
    width: 100%;
    & .MuiButtonGroup-grouped:hover {
      color: #132C1D;
      border: 1px solid #E30311;
      background-color: #E3031120;
    }
`;
